import { Directive, EventEmitter, HostListener, Input, Output } from "@angular/core";

@Directive({
    selector: "button[adaptButtonToggle]",
    standalone: false,
    host: {
        "data-toggle": "button",
        "[attr.aria-pressed]": "toggleEnabled ? 'true' : 'false'",
        "[class.active]": "toggleEnabled",
    },
})
export class ButtonToggleDirective {
    @Input("adaptButtonToggle") public toggleEnabled = false;
    @Output() public adaptButtonToggleChange = new EventEmitter<boolean>();

    @HostListener("click")
    public onClick() {
        this.adaptButtonToggleChange.emit(!this.toggleEnabled);
    }
}
